<script>
import SeoTextsService from "../services/api/SeoTextsService";

export default {
    name: "SeoTexts",
    data() {
        return {
            seoText: '',
        }
    },
    methods: {
        getSeoText() {
            if(!this.seoTextParams) return false;

            SeoTextsService.setLocale(this.$store.state.language.appLanguage);
            SeoTextsService.getSeoTexts(this.seoTextParams)
                .then((res) => {
                    this.seoText = res.data ? res.data.text : '';
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    },
    mounted() {
        this.getSeoText();
    }
}
</script>
